<template>
  <div class="d-sm-flex coply align-items-center justify-content-between">
    <p>Copyright &copy; 2024.捷捷AI官网 All rights reserved.</p>
    <p><a href="http://beian.miit.gov.cn/">渝ICP备13003919号-21</a></p>
    <p>
      <a class="gawBox" href="https://beian.mps.gov.cn/#/query/webSearch?code=50019002504528" rel="noreferrer" target="_blank">
        <img src="../../assets/img/gaw.png" alt="" class="gawImg"> 
        <p>渝公网安备50019002504528号</p>
      </a>
    </p>
    <ul>
      <li>
        <span class="linkBtn" @click="toAgreement(1)"> 用户协议</span>
        <span class="linkBtn" @click="toAgreement(2)"> 隐私权保护声明</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 查看协议
    toAgreement(type) {
      if (type === 1) {
        window.open("/用户协议.pdf");
      }
      if (type === 2) {
        window.open("/隐私权保护申明.pdf");
      }
    },
  },
};
</script>

<style scoped lang="less">
.gawBox {
  display: flex;
  align-items: center;
  .gawImg {
    width: 15px;
    margin-right: 4px;
  }
}

.linkBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>
